module.exports = __webpack_public_path__ + "static/13-d88772f381032b3566c6217e30e7d672.jpg";